import { StyleSheet, Text, View, Image, TouchableOpacity } from "react-native";
import React from "react";
import LinearGradient from "react-native-linear-gradient";
import BackArrow from "@assets/svg/BackArrow";
import MenuIcon from "@assets/svg/MenuIcon";
import ArrowRightSmall from "@assets/svg/ArrowRightSmall";
import Button from "@components/Button";
import { useNavigation } from "@react-navigation/native";

import t from "@constants/localization";
import { useSelector } from "react-redux";

const PATH = "screens/ReferEarn";

const NoReferredClComponent = ({
  toggleShowOtherReferModal,
  amount,
  referKare,
  wa,
  backgroundImage,
}) => {
  const navigation = useNavigation();
  return (
    <>
      {backgroundImage && (
        <Image
          source={{ uri: backgroundImage }}
          style={styles.bgImage}
          resizeMode="cover"
        />
      )}
      <LinearGradient
        style={styles.bgGradient1}
        colors={["rgba(0, 0, 0, 1)", "rgba(0, 0, 0, 0)"]}
      >
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <BackArrow color="#fff" />
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.menuButton}
            onPress={toggleShowOtherReferModal}
          >
            <MenuIcon color="#fff" />
          </TouchableOpacity>
        </View>
        <View style={styles.upperContent}>
          <Text variant="title_18_semi" style={styles.titleText}>
            {t(`${PATH}/earnThroughReferal`)}
          </Text>
          <Text style={styles.amountText}>₹{amount}</Text>
        </View>
      </LinearGradient>
      <LinearGradient
        style={styles.bgGradient1}
        colors={["rgba(0, 0, 0, 0)", "rgba(0, 0, 0, 1)"]}
      >
        <View style={styles.lowerContent}>
          <Text style={styles.contentText}>{t(`${PATH}/sharamjiEarn`)}</Text>
          <TouchableOpacity
            style={styles.getToKnowButton}
            onPress={() => navigation.navigate("ReferEarnStepsScreen", { wa })}
          >
            <Text variant="caption_1" style={styles.getToKnowText}>
              {t(`${PATH}/stepsToKnow`)}
            </Text>
            <View style={styles.whiteCircle}>
              <ArrowRightSmall color="#000" />
            </View>
          </TouchableOpacity>
        </View>
        <View style={styles.ctaContainer}>
          <Button
            buttonWidth="100%"
            btnText={t(`${PATH}/referNow`)}
            buttonFontType="head1"
            height={56}
            borderRadius={10}
            onPress={referKare}
          />
        </View>
      </LinearGradient>
    </>
  );
};

export default NoReferredClComponent;

const styles = StyleSheet.create({
  bgImage: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
  },
  header: {
    padding: 5,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  backButton: {
    padding: 15,
    borderRadius: 10,
  },
  menuButton: {
    padding: 15,
    height: 42,
    width: 42,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 32,
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    marginTop: 5,
  },
  bgGradient1: {
    flex: 1,
  },
  upperContent: {
    padding: 30,
    marginTop: 30,
  },
  lowerContent: {
    padding: 30,
    paddingBottom: 0,
    justifyContent: "flex-end",
    flex: 1,
  },
  titleText: {
    fontSize: 25,
    color: "#fff",
    fontWeight: "700",
    textAlign: "center",
  },
  amountText: {
    fontSize: 50,
    color: "#fff",
    fontWeight: "500",
    textAlign: "center",
  },
  contentText: {
    fontSize: 18,
    color: "#FFF6C8",
    textAlign: "center",
    fontWeight: "600",
  },
  getToKnowText: {
    fontSize: 16,
    color: "#fff",
    fontWeight: "700",
    textAlign: "center",
  },
  getToKnowButton: {
    padding: 10,
    flexDirection: "row",
    justifyContent: "center",
  },
  whiteCircle: {
    width: 20,
    height: 20,
    backgroundColor: "white",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 20,
    marginLeft: 5,
  },
  ctaContainer: {
    padding: 15,
  },
});
